module.exports = __webpack_public_path__ + "img/c-technics-4.png";